<template>
  <div
    class="custom-modal"
    :class="{
      'custom-modal--shown': show
    }"
    @click.self="onCloseSelf">
    <div class="custom-modal__content"
         :class="getModalSize">
      <div class="custom-modal__header">
        <slot name="header">
          <h1 class="custom-modal__heading">
            {{ heading }}
          </h1>
        </slot>

        <button class="custom-modal__close"
                aria-label="close"
                @click="onClose">
          <span class="visually-hidden">
            Close modal
          </span>
          <font-awesome-icon :icon="['fal', 'times']">
          </font-awesome-icon>
        </button>
      </div>

      <div class="custom-modal__body">
        <slot></slot>
      </div>

      <div class="custom-modal__footer">
        <slot name="footer">
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomModal",
  props: {
    heading: {
      type: String,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    staticBackdrop: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "md"
    }
  },
  computed: {
    getModalSize () {
      return `custom-modal__content--${this.size}`;
    }
  },
  methods: {
    onClose () {
      this.$emit( "close" );
    },
    onCloseSelf ( e ) {
      if ( this.staticBackdrop ) {
        e.stopPropagation();
      } else {
        this.$emit( "close" );
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../Styles/utils/colors.less";

@border-radius: 10px;

.custom-modal {
  position: fixed;
  top: -20px;
  bottom: -20px;
  left: -20px;
  right: -20px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  transition: opacity 0.3s;

  &__content {
    display: flex;
    flex-direction: column;
    width: 60%;
    background: #fff;
    border-radius: @border-radius;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.5);
    max-height: 95vh;
    overflow: hidden;

    &--md {
      width: 60%;
    }

    &--sm {
      width: 50%;

      @media screen and (max-width: 800px) {
        width: 60%;
      }
    }

    &--xs {
      width: 35%;

      @media screen and (max-width: 800px) {
        width: 50%;
      }

      @media screen and (max-width: 500px) {
        width: 70%;
      }
    }
  }

  &__header {
    background: #e3f3ea;
    border-radius: @border-radius @border-radius 0 0;
    padding: 15px 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__footer {
    padding: 15px 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__heading {
    color: @color-accent-1;
    font-weight: 600;
    margin: 0;
  }

  &__close {
    background: none;
    font-size: 60px;
    height: 60px;
    width: 60px;
    border: 0;
    color: @color-accent-6;
    position: relative;
    padding: 0;
    transition: opacity 0.2s;

    svg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
    }

    &:hover {
      color: @color-accent-6-dark;
    }
  }

  &__body {
    padding: 15px 10%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  &--shown {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
  }
}
</style>
